import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

interface StyledGridContainerProps {
  children: ReactNode;
  pagination?: ReactNode;
  headerHeight?: string;
}

export const CenteredCellBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
});

export const LeftAlignedCellBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  height: '100%',
});

export const RightAlignedCellBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
  height: '100%',
});

const StyledGridContainer = ({
  children,
  pagination,
  headerHeight = '200px',
}: StyledGridContainerProps) => {
  return (
    <Box
      height={`calc(100vh - ${headerHeight})`}
      bgcolor="var(--bg-color)"
      width="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        flex={1}
        width="auto"
        margin="0 auto"
        minHeight={0}
        sx={{
          overflowX: 'hidden',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          width: '100%',
        }}
      >
        {children}
      </Box>
      {pagination && (
        <Box
          sx={{
            flexShrink: 0,
            width: '100%',
            position: 'relative',
            zIndex: 10,
          }}
        >
          {pagination}
        </Box>
      )}
    </Box>
  );
};

export default StyledGridContainer;
